import { getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync,updateSorting } from "./TimesheetPeriodTypeSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import { getValueFromResource } from "../../../common/timeLiveFunction";

const itemClass = 'ms-1 ms-lg-0';

export const TimesheetPeriodTypeItem = (props: any) => {
    const { TimesheetPeriodTypeList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;

    const dispatch = useAppDispatch();

    const {isReload,selectedRecord,sortOrder, sortColumn,pageSize} = useAppSelector((state)=>state.timesheetPeriodType);

  
    const onEditClick = (AccountTimesheetPeriodTypeId: number) => {
        dispatch(getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync(AccountTimesheetPeriodTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }


    return (
        <>
        
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >                        
                    <th style={{width:'40%'}}>
                        {/* {t('Timesheet Period Type')}  */}
                        {getValueFromResource('Timesheet Period Type',dispatch, t)}
                             {sortColumn === 'SystemTimesheetPeriodType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemTimesheetPeriodType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemTimesheetPeriodType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemTimesheetPeriodType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemTimesheetPeriodType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'20%'}}>
                                    {/* {t('Initial Days Of The Period')}  */}
                                    {getValueFromResource('Initial Days Of The Period',dispatch, t)}
                             {sortColumn === 'SystemInitialDaysOfThePeriod' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemInitialDaysOfThePeriod") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemInitialDaysOfThePeriod") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemInitialDaysOfThePeriod") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemInitialDaysOfThePeriod") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'20%'}}>
                                    {/* {t('Initial Days Of The Month')}  */}
                                    {getValueFromResource('Initial Days Of The Month',dispatch, t)}
                             {sortColumn === 'InitialDayOfTheMonth' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "InitialDayOfTheMonth") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "InitialDayOfTheMonth") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "InitialDayOfTheMonth") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "InitialDayOfTheMonth") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {/* {TimesheetPeriodTypeList.length === 0 && <tr><td>{t('No Record Found.')}</td></tr>} */}
                    {TimesheetPeriodTypeList.length > 0 && TimesheetPeriodTypeList.map((TimesheetPeriodTypeDetail: any, i: any) => (
                        <tr key={i}>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor ' onClick={IsEdit ? () => onEditClick(TimesheetPeriodTypeDetail.AccountTimesheetPeriodTypeId) : undefined}>
                                <span className="   d-block "
                                >{TimesheetPeriodTypeDetail.SystemTimesheetPeriodType}</span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor'>
                                <span className="   d-block "
                                >{TimesheetPeriodTypeDetail.SystemInitialDaysOfThePeriod}</span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor'>
                                <span className="   d-block "
                                >{TimesheetPeriodTypeDetail.InitialDayOfTheMonth}</span>
                            </td>
                           
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                    {IsEdit &&
                                                        <>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => {
                                                                        onopenModal();
                                                                        dispatch(getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync(TimesheetPeriodTypeDetail.AccountTimesheetPeriodTypeId))
                                                                            .unwrap()
                                                                            .then((originalPromiseResult) => {
                                                                               
                                                                            })
                                                                            .catch((rejectedValueOrSerializedError) => {
                                                                            })
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }                                                    
                                                </Dropdown.Menu>
                                            </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {TimesheetPeriodTypeList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }

        </>
    )


}

